import React from 'react'

export const WhyChoseLegalUtopiaPortal = ({
  className,
}: {
  className: string
}) => (
  <div
    className={`${className} text-[#CCE0DD] flex flex-col text-left p-4 sm:p-10 rounded-xl max-w-[734px]`}
  >
    <span className='text-white text-center sm:text-left text-sm md:text-2xl font-medium pb-10'>
      Why choose Legal Utopia's Lawyer Portal?
    </span>

    <span className='text-xs sm:text-base pb-4 text-justify'>
      The Lawyer Portal provides an all-in-one business development solution
      tailored specifically for legal professionals and firms. With robust tools
      for profile management, scheduling, and client engagement, Legal Utopia
      simplifies the way you promote and manage your practice online.
      <br />
      <br />
      You can use our trusted platform to connect with clients, and build your
      reputation, while focusing on delivering top-notch legal services.
    </span>

    <span className='font-medium sm:font-bold text-sm sm:text-lg '>
      Ready to Get Started?
    </span>

    <span className='text-xs sm:text-base pb-5 sm:pb-10 text-justify'>
      Select a plan today and take control of your online presence with Legal
      Utopia's Lawyer Portal.
    </span>

    <span className='text-xs sm:text-sm font-medium text-justify'>
      Note: Our Customer Support team is always available to assist with any
      questions or additional guidance you may need.
    </span>
  </div>
)
